/**
 * Get an element by a reference
 */
const getElementByRef = function(reference: string): ?HTMLElement {
  return this.querySelector(`[ref="${reference}"]`);
};

/**
 * Get multiple elements by a reference
 */
const getElementsByRef = function(reference: string): NodeList<HTMLElement> {
  return this.querySelectorAll(`[ref="${reference}"]`);
};

HTMLElement.prototype.getElementByRef = getElementByRef;
Document.prototype.getElementByRef = getElementByRef;

HTMLElement.prototype.getElementsByRef = getElementsByRef;
Document.prototype.getElementsByRef = getElementsByRef;
